<template>
	<div id="home" class='page'>
		<div>
		<div class="glide">
		<div class='scrolldown-icon'></div>
            <div class="glide__bullets" data-glide-el="controls[nav]">
                <div class="bullet" v-for="(i,index) in p.slider" :key="index" :data-glide-dir='"="+(index)'>
                	<div class='bar'></div>
            </div>
            </div>
			<div class="glide__track" data-glide-el="track">
				<ul class="glide__slides">
					<li class="glide__slide" v-for='(slide, index) in p.slider'>
						<div class="bg" id='bg-one' v-bind:style="{backgroundImage: 'url(' + slide.image.url.replace('?auto=compress,format','') + ')'}">
							<div class='headline-box'>
								<div class='bracket'></div>
								<h2 class='headline' v-html="slide.headline" data-aos="fade-in" :data-aos-duration=1000> </h2>
							</div>
						</div>
					</li>
				</ul>
			</div>

			</div>
		</div>
	<About :langsufix='langsufix' :content=p> </About>
	<Leistungen :langsufix='langsufix' :content=p> </Leistungen>
	<Teaser :langsufix='langsufix' :content='p'> </Teaser>
	<div v-if="p.slideshow.length > 0" class="slider_container">

		<div class="inner_container">
			<div class="slide-btn-left prev"></div>
			<div class="slide-btn-right next"></div>

		<div class="siema">
			<!-- <div v-for='(slide, index) in p.slideshow'> -->
				<!-- <img :src="slide.slide.url" alt="" > -->
				<!-- <div class="img-div" v-bind:style="{backgroundImage: 'url(' + slide.slide.url + ')'}"> </div> -->
				<img v-for='(slide, index) in p.slideshow' class="img-div" v-bind:src="slide.slide.url"> </img>

			<!-- </div> -->
		</div>
	</div>
</div>

	</div>

</template>
<script>
	import Navel from '@/components/Navel.vue'
	// import { Glide, GlideSlide } from 'vue-glide-js'
	import 'vue-glide-js/dist/vue-glide.css'
	import Glide from '@glidejs/glide'
	import About from '@/components/About.vue'
	import Leistungen from '@/components/Leistungen.vue'
	import Teaser from '@/components/Teaser.vue'
	import Siema from 'siema';


	export default {
		name: 'home',
		components: {
			About,
			Leistungen,
			Teaser,

		},
		props: {
			langsufix: String,
		},
		data() {
			return {
				p: {}
			}
		},
		updated: function () {
  			this.$nextTick(function () {
			var glide = new Glide( '.glide',{
				autoplay: 8000,
				hoverpause: false,
				animationTimingFunc: 'ease-in-out',
				animationDuration: 1000,
				perView: 1
			})

			glide.mount();
  			})
				var mySiema = new Siema();
				document.querySelector('.prev').addEventListener('click', () => mySiema.prev());
				document.querySelector('.next').addEventListener('click', () => mySiema.next());



		},
		mounted() {
		},
		created () {
			this.getContent();


		},
		methods: {
			getContent () {
				this.$prismic.client.getByUID('page','home-'+this.langsufix)
				.then((document) => {
					console.log(document.data);
					this.p = document.data;

				})
			},
		}
	}
</script>

<style lang='less' scoped>
@import '../less/variables.less';
@import '../less/glide.core.less';
@import '../less/glide.theme.less';

#home {
	position: relative;
}
.slider_container {
	background-color: white;
	width: 100%;
	height: 700px;

	padding-bottom: 50px;
	padding-top: 50px;


	@media (max-width: 1000px) {
		height: 650px;
	}

		@media (max-width: 800px) {
			height: 500px;
		}
		@media (max-width: 500px) {
			height: 350px;
		}

		@media (max-width: 400px) {
			height: 250px;
		}
	.inner_container {
		position: relative;
		// width: 80%;
		max-width: 1000px;
		margin-left:auto;
		margin-right:auto;
		left:0;
		right:0;
		// background-color: purple;

		height: 250px;
		img {
			width: 100%;
		}
	}


	.slide-btn-left {
		position: absolute;
		// background-color: green;
		width: 100px;
		height: 650px;
		left: 0px;
		// top: 50%;
		z-index: 2;
		opacity: 0.5;
		background-image: url("/images/ar-left.svg");
		background-repeat: no-repeat;
		background-position: center center;
		background-size: 50% auto;
		cursor: pointer;
		// bottom: 0px;
		&:hover {
			opacity: 1;
		}
		@media (max-width: 1000px) {
			height: 650px;
		}

			@media (max-width: 800px) {
				height: 500px;
			}
			@media (max-width: 500px) {
				height: 350px;
			}

			@media (max-width: 400px) {
				height: 250px;
			}


	}

	.slide-btn-right {
		position: absolute;
		// background-color: yellow;
		width: 100px;
		height: 650px;
		right: 0px;
		z-index: 2;
		opacity: 0.5;
		background-image: url("/images/ar-right.svg");
		background-repeat: no-repeat;
		background-position: center center;
		background-size: 50% auto;
		cursor: pointer;
		&:hover {
			opacity: 1;
		}
		@media (max-width: 1000px) {
			height: 650px;
		}

			@media (max-width: 800px) {
				height: 500px;
			}
			@media (max-width: 500px) {
				height: 350px;
			}

			@media (max-width: 400px) {
				height: 250px;
			}

	}

}
.siema {
	position: relative;
	// width: 100%;
	// margin-left:auto;
	// margin-right:auto;
	// left:0;
	// right:0;
	// div {
	// 	position: relative;
	// 	// height: 650px;
	// 	width: 100%;
	// }
}
.scrolldown-icon {
	width: 25px;
	height: 25px;
	// background-color: red;
	position: absolute;
	z-index: 2000;
	bottom: 50px;
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	background-image: url('/images/scrolldown.svg');
	background-repeat: no-repeat;
	background-size: 100% 100% ;


}
.controlset {
	position: absolute;
	background-color: green;
	top: 0px;
	z-index: 2000;
}
.bullet {

	width: 6%;
	height: 30px;
	display: inline-block;
	margin-right: 5%;
	&:hover {
		.bar {
			background-color: rgba(255,255,255,0.8);

		}

	}

	.bar {
		width: 100%;
		position: relative;
		// background-color: red;
		height: 4px;
		margin-top: 12px;
		background-color:rgba(255,255,255,0.2);

	}

}
ul {
	margin: 0;
}
.glide__bullets {
	position: absolute;
	left: 30%;
	bottom: 130px;
    width: 70%;
    padding-left: 0px;
    margin-left: 0px;
    display: inherit;
    // background-color: red;

}
.glide__bullet {
}

.glide__bullet--active {
	background-color: transparent;

	.bar {
		background-color:rgba(255,255,255,1);
	}
}
.glide__slides {

	margin: 0px;
}
#glide-top {
	margin: 0px !important;
}
.bracket {
	position: absolute;
	width: 340px;
	height: 100%;
	// background-color: red;
	right: 44px;
	top: 5px;
	background-image: url('/images/bracket.svg');
	background-repeat: no-repeat;
	background-size: 100% 100%;
    background-position: center left;

	@media (max-width: @mobile_width) {
		right: 0px;
        width: 290px;
        display: none;

	}
}
.bg {
	position: relative;
	background-position: center center;
	background-size: cover;
	width: 100%;
	height: 100vh;
	padding: 0px 0px;
	margin: 0px 0px;
	top: 0px;
	left: 0px;
 // background-color: red;
 // background-image: url('/images/bg_home.jpg');
}

.headline-box {
	text-align: right;
	padding-right: 9%;
	position: absolute;
	top: 40vh;
	right: 0px;
	// max-width: 1000px;
	padding-top: 50px;
	padding-bottom: 50px;
	display: table;
    width: 100%;

	// background-color: yellow;
	// right: 60px;
	// background-color: red;
	h2 {
		.fdb1;

		// background-color: green;
		vertical-align: middle;
		display: table-cell;
		text-transform: uppercase;
		max-width: 1000px;

	}
}
</style>
